import React from 'react';

import { Card } from '../../../components/card/card';
import { Text } from '../../../components/text/text';
import { Title } from '../../../components/title/title';
import { cn } from '../../../utils/classname';

interface SupportCardProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  text: React.ReactNode;
  className?: string;
  afterContent?: React.ReactNode;
  column?: boolean;
  reverted?: boolean;
}

const SupportCardComponent: React.FC<SupportCardProps> = ({
  icon,
  title,
  text,
  className,
  afterContent,
  column,
  reverted
}) => (
  <Card
    content={
      <React.Fragment>
        <Title level="3" weight="bold">
          {title}
        </Title>
        <Text size="large">{text}</Text>
      </React.Fragment>
    }
    icon={icon}
    className={cn('rc-support-card', className)}
    afterContent={afterContent}
    column={column}
    reverted={reverted}
    density="large"
  />
);

export default SupportCardComponent;
